function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".iceberg-main_svg__st53{fill:#cfd6ec}.iceberg-main_svg__st61{fill:none;stroke:#2d327e;stroke-miterlimit:10}.iceberg-main_svg__st66{fill:#192f28}.iceberg-main_svg__st70{fill:#fff}.iceberg-main_svg__st72{fill:#3eb883}.iceberg-main_svg__st73{fill:#7dc9a9}.iceberg-main_svg__st76{fill:#2d327e}");

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 406.278,
  y1: 535.66,
  x2: 405.231,
  y2: 390.468
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_1_)",
  d: "M436.3 364.9l-61.7 119 5 20.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 519.187,
  y1: 500.416,
  x2: 470.592,
  y2: 419.424
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_2_)",
  d: "M558.8 330l-92 53.2-30.7-17.7-56.5 139 25.6-32.8 60.9-35.7.9-52.8-.9 52.8 62.7 35.7L559 330h-.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 341.835,
  y1: 318.907,
  x2: 428.036,
  y2: 491.308
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_3_)",
  d: "M344.1 347.9l.2 117.9 30.3 18.1 61.5-118.5-1.3-.7z"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 723.506,
  y1: 473.431,
  x2: 602.615,
  y2: 313.646
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_4_)",
  d: "M651.4 276.7h-.2L620.1 330H559l31.1 159.1L620.3 330l60.5 34.9 92.9-17.2z"
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 296.422,
  y1: 497.286,
  x2: 317.248,
  y2: 313.549
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_5_)",
  d: "M282.8 347.8h61.1v-35.4z"
});

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: 226.479,
  y1: 660.173,
  x2: 346.318,
  y2: 591.843
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_6_)",
  d: "M282.8 572.6l.2 93.9h30.6l30.5-129.4z"
});

var _ref14 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 268.57,
  y1: 519.575,
  x2: 249.374,
  y2: 672.097
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_7_)",
  d: "M252.3 554.9l-30.7 76.2 61.4 35.4-.2-93.9z"
});

var _ref16 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_8_",
  gradientUnits: "userSpaceOnUse",
  x1: 320.391,
  y1: 487.354,
  x2: 235.342,
  y2: 443.338
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_8_)",
  d: "M251.4 364.9L191 507.1l61.3-35.4z"
});

var _ref18 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_9_",
  gradientUnits: "userSpaceOnUse",
  x1: 78.343,
  y1: 610.91,
  x2: 296.997,
  y2: 539.427
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_9_)",
  d: "M283.4 537.4l-.6-35.5-91.8 5.2v70.8l30.6 53.2 30.7-76.2z"
});

var _ref20 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_10_",
  gradientUnits: "userSpaceOnUse",
  x1: 762.13,
  y1: 448.497,
  x2: 657.008,
  y2: 644.024
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_10_)",
  d: "M651.4 525.1l-31.1 159.1L743 613.3l-62.2-106.7z"
});

var _ref22 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_11_",
  gradientUnits: "userSpaceOnUse",
  x1: 723.163,
  y1: 703.523,
  x2: 363.645,
  y2: 614.169
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_11_)",
  d: "M466.1 507.4l-60.4 300.7 60.8.3 153.8-88.8-91.5-247.9z"
});

var _ref24 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_12_",
  gradientUnits: "userSpaceOnUse",
  x1: 734.664,
  y1: 568.119,
  x2: 817.711,
  y2: 407.283
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_12_)",
  d: "M835 454l-92-17.7 30.7 88.5 61.3-35.4z"
});

var _ref26 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_13_",
  gradientUnits: "userSpaceOnUse",
  x1: 657.472,
  y1: 618.159,
  x2: 759.949,
  y2: 494.84
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_13_)",
  d: "M773.7 418.6L712.4 454 743 613.3l30.7-88.5-30.7-88.5z"
});

var _ref28 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_14_",
  gradientUnits: "userSpaceOnUse",
  x1: 620.345,
  y1: 489.5,
  x2: 712.353,
  y2: 489.5
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_14_)",
  d: "M650.9 489.6l.2-.2h-.1z"
});

var _ref30 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_15_",
  gradientUnits: "userSpaceOnUse",
  x1: 391.419,
  y1: 263.73,
  x2: 303.386,
  y2: 319.683
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_15_)",
  d: "M313.6 294.6l-30.8 53.2 61.3-35.5z"
});

var _ref32 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_16_",
  gradientUnits: "userSpaceOnUse",
  x1: 698.035,
  y1: 234.586,
  x2: 753.989,
  y2: 397.97
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_16_)",
  d: "M773.7 347.7l-92.9 17.2 41.8 24.2 26.5 15.3 24.6 14.2L835 454z"
});

var _ref34 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_17_",
  gradientUnits: "userSpaceOnUse",
  x1: 797.093,
  y1: 490.626,
  x2: 785.746,
  y2: 426.617
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_17_)",
  d: "M743 436.3l92 17.7-61.3-35.4z"
});

var _ref36 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_18_",
  gradientUnits: "userSpaceOnUse",
  x1: 777.969,
  y1: 467.715,
  x2: 699.994,
  y2: 408.653
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_18_)",
  d: "M722.6 389.1l-41.8-24.2.7 57.3.2 14.1 61.3-35.4 6.1 3.5z"
});

var _ref38 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_19_",
  gradientUnits: "userSpaceOnUse",
  x1: 825.805,
  y1: 429.755,
  x2: 703.607,
  y2: 426.846
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_19_)",
  d: "M749.1 404.4l-6.1-3.5-61.3 35.4 18.4 10.6 12.3 7.1 61.3-35.4z"
});

var _ref40 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_20_",
  gradientUnits: "userSpaceOnUse",
  x1: 790.895,
  y1: 531.857,
  x2: 693.526,
  y2: 523.119
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_20_)",
  d: "M712.4 454l-12.3-7.1-18.4-10.6-30.3 52.8-.3.3 29.7 17.2L743 613.3z"
});

var _ref42 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_21_",
  gradientUnits: "userSpaceOnUse",
  x1: 585.224,
  y1: 637.362,
  x2: 464.364,
  y2: 468.01
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_21_)",
  d: "M405.2 471.7l60.9 35.7 62.7-35.7-62.7-35.7z"
});

var _ref44 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_22_",
  gradientUnits: "userSpaceOnUse",
  x1: 169.653,
  y1: 654.611,
  x2: 371.736,
  y2: 464.744
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_22_)",
  d: "M374.6 483.9l-30.3-18.1-61.5 36.1.6 35.5-31.1 17.5 30.5 17.7 61.3-35.5-30.6-17.7z"
});

var _ref46 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_23_",
  gradientUnits: "userSpaceOnUse",
  x1: 381.625,
  y1: 373.47,
  x2: 279.806,
  y2: 405.866
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref47 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_23_)",
  d: "M282.8 347.8l-31.4 17.1.9 106.8 30.5-41.1 61.3-82.8z"
});

var _ref48 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_24_",
  gradientUnits: "userSpaceOnUse",
  x1: 441.133,
  y1: 634.8,
  x2: 279.987,
  y2: 442.32
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_24_)",
  d: "M344.1 347.8l-61.3 82.8-30.5 41.1-61.3 35.4 91.8-5.2 61.5-36.1z"
});

var _ref50 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_25_",
  gradientUnits: "userSpaceOnUse",
  x1: 740.461,
  y1: 523.497,
  x2: 498.681,
  y2: 525.6
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref51 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_25_)",
  d: "M559 330l-30.2 141.7 91.5 247.9v-35.4l-30.2-195.1z"
});

var _ref52 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_26_",
  gradientUnits: "userSpaceOnUse",
  x1: 620.345,
  y1: 471.687,
  x2: 620.345,
  y2: 471.687
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref53 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_27_",
  gradientUnits: "userSpaceOnUse",
  x1: 655.751,
  y1: 585.907,
  x2: 632.264,
  y2: 483.991
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref54 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_27_)",
  d: "M620.3 471.7l-30.2 17.4 30.2 17.7 31.1 18.3 29.4-18.5z"
});

var _ref55 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_28_",
  gradientUnits: "userSpaceOnUse",
  x1: 769.644,
  y1: 660.719,
  x2: 604.022,
  y2: 586.115
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_28_)",
  d: "M620.3 506.8l-30.2-17.7 30.2 195.1 31.1-159.1z"
});

var _ref57 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_29_",
  gradientUnits: "userSpaceOnUse",
  x1: 310.147,
  y1: 615.643,
  x2: 479.393,
  y2: 658.742
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_29_)",
  d: "M405.2 471.7l.1 50.5.4 285.9 60.4-300.7z"
});

var _ref59 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_30_",
  gradientUnits: "userSpaceOnUse",
  x1: 330.297,
  y1: 559.479,
  x2: 356.474,
  y2: 589.146
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref60 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_30_)",
  d: "M374.6 483.9l-61.1 35.5 30.6 17.7-30.5 129.4 55.1-135.4 10.9-26.6z"
});

var _ref61 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_31_",
  gradientUnits: "userSpaceOnUse",
  x1: 255.637,
  y1: 716.158,
  x2: 431.191,
  y2: 626.804
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_31_)",
  d: "M405.3 522.2l-.1-50.5-25.6 32.8-10.9 26.6-55.1 135.4 92.1 141.6z"
});

var _ref63 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_32_",
  gradientUnits: "userSpaceOnUse",
  x1: 665.539,
  y1: 504.808,
  x2: 900.49,
  y2: 748.71
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref64 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_32_)",
  d: "M835 489.4l180.7 419.1L826.2 863l-52.5-338.2z"
});

var _ref65 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_33_",
  gradientUnits: "userSpaceOnUse",
  x1: 617.864,
  y1: 664.735,
  x2: 801.31,
  y2: 818.83
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref66 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_33_)",
  d: "M620.3 719.6v-35.4L743 613.3l24.3 333.5z"
});

var _ref67 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_34_",
  gradientUnits: "userSpaceOnUse",
  x1: 782.213,
  y1: 1003.648,
  x2: 786.616,
  y2: 520.816
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.177,
  stopColor: "#f5f7fb",
  stopOpacity: 0.176
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.463,
  stopColor: "#edf0f8",
  stopOpacity: 0.462
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref68 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_34_)",
  d: "M773.7 524.8L743 613.3l24.3 333.5 58.9-83.8z"
});

var _ref69 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_35_",
  gradientUnits: "userSpaceOnUse",
  x1: 448.802,
  y1: 809.351,
  x2: 576.481,
  y2: 890.067
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref70 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_35_)",
  d: "M620.3 719.6l-153.8 88.8 13 218.6z"
});

var _ref71 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_36_",
  gradientUnits: "userSpaceOnUse",
  x1: 427.246,
  y1: 936.015,
  x2: 523.931,
  y2: 819.665
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref72 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_36_)",
  d: "M405.7 808.1l73.8 218.9-13-218.6z"
});

var _ref73 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_37_",
  gradientUnits: "userSpaceOnUse",
  x1: 219.649,
  y1: 839.509,
  x2: 438.317,
  y2: 783.741
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref74 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_37_)",
  d: "M313.6 666.5l-71.3 316.3 163.4-174.7z"
});

var _ref75 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_38_",
  gradientUnits: "userSpaceOnUse",
  x1: 200.675,
  y1: 979.384,
  x2: 300.47,
  y2: 583.139
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref76 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_38_)",
  d: "M283 666.5l-71.7 102 31 214.3 71.3-316.3z"
});

var _ref77 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_39_",
  gradientUnits: "userSpaceOnUse",
  x1: 153.231,
  y1: 775.877,
  x2: 228.395,
  y2: 685.426
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref78 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_39_)",
  d: "M221.6 631.1l-10.3 137.4 71.7-102z"
});

var _ref79 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_40_",
  gradientUnits: "userSpaceOnUse",
  x1: 45.148,
  y1: 623.735,
  x2: 384.158,
  y2: 933.393
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref80 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_40_)",
  d: "M191 577.9l-38.8 125.7 90.1 279.2-31-214.3 10.3-137.4z"
});

var _ref81 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_41_",
  gradientUnits: "userSpaceOnUse",
  x1: 450.992,
  y1: 851.741,
  x2: 362.937,
  y2: 1001.434
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref82 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_41_)",
  d: "M405.7 808.1l73.8 218.9-237.2-44.2z"
});

var _ref83 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_42_",
  gradientUnits: "userSpaceOnUse",
  x1: 478.341,
  y1: 863.126,
  x2: 695.542,
  y2: 893.945
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_42_)",
  d: "M620.3 719.6l147 227.2-287.8 80.2z"
});

var _ref85 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_43_",
  gradientUnits: "userSpaceOnUse",
  x1: 26.619,
  y1: 697.027,
  x2: 226.209,
  y2: 570.816
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref86 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_43_)",
  d: "M191 507.1L0 794.7l152.2-91.1L191 577.9z"
});

var _ref87 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_44_",
  gradientUnits: "userSpaceOnUse",
  x1: -10.905,
  y1: 856.698,
  x2: 193.088,
  y2: 843.49
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref88 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_44_)",
  d: "M0 794.7l40.9 188.1h201.4l-90.1-279.2z"
});

var _ref89 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_45_",
  gradientUnits: "userSpaceOnUse",
  x1: 1160.105,
  y1: 568.173,
  x2: 875.129,
  y2: 626.331
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref90 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_45_)",
  d: "M835 454v35.4l129 299.3 101.8-85.1-36.2-116.9z"
});

var _ref91 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_46_",
  gradientUnits: "userSpaceOnUse",
  x1: 793.499,
  y1: 455.053,
  x2: 648.282,
  y2: 413.336
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref92 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_46_)",
  d: "M681.5 422.2l-.7-57.3-60.5-34.9v141.7l30.7 17.7 30.7-53.1z"
});

var _ref93 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_47_",
  gradientUnits: "userSpaceOnUse",
  x1: 517.014,
  y1: 383.858,
  x2: 618.402,
  y2: 413.43
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref94 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_47_)",
  d: "M620.3 330l-30.2 159.1 30.2-17.4z"
});

var _ref95 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_48_",
  gradientUnits: "userSpaceOnUse",
  x1: 954.381,
  y1: 707.926,
  x2: 1082.329,
  y2: 853.322
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref96 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_48_)",
  d: "M1065.8 703.6l-50.1 204.9L964 788.7z"
});

var _ref97 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_49_",
  gradientUnits: "userSpaceOnUse",
  x1: 979.573,
  y1: 1082.807,
  x2: 803.935,
  y2: 773.405
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref98 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_49_)",
  d: "M767.3 946.8l58.9-83.8 189.5 45.5z"
});

var _ref99 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_50_",
  gradientUnits: "userSpaceOnUse",
  x1: 344.88,
  y1: 215.754,
  x2: 443.028,
  y2: 175.549
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref100 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_50_)",
  d: "M344.1 206.1l61.3-35.4v35.4l-30.6 17.7z"
});

var _ref101 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_51_",
  gradientUnits: "userSpaceOnUse",
  x1: 394.629,
  y1: 275.503,
  x2: 573.187,
  y2: 322.804
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref102 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_51_)",
  d: "M313.4 294.6l153.4-88.5 153.3 88.5-153.3 88.6z"
});

var _ref103 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_52_",
  gradientUnits: "userSpaceOnUse",
  x1: 418.091,
  y1: 186.934,
  x2: 596.649,
  y2: 234.234
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref104 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_52_)",
  d: "M620.1 294.6l-30.6-88.5-30.7-17.7V153l-61.3-70.9-30.7-17.7-30.7 17.7-61.3 141.7-30.7-17.7-30.7 88.5"
});

var _ref105 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_53_",
  gradientUnits: "userSpaceOnUse",
  x1: 392.647,
  y1: 181.766,
  x2: 443.495,
  y2: 226.701
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref106 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_53_)",
  d: "M313.4 294.6l30.7-88.5 30.7 17.7 61.3-141.7 30.7-17.7v106.3l-30.7 17.7-9.4 161.5-82.8-37.6z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st53",
  d: "M436.1 82.1l30.7-17.7 30.7 17.7-30.7 17.7zm153.4 124l-61.4 35.4-30.6-17.7 61.3-35.4z"
});

var _ref108 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_54_",
  gradientUnits: "userSpaceOnUse",
  x1: 491.866,
  y1: 218.977,
  x2: 501.326,
  y2: 317.125
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref109 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_54_)",
  d: "M528.1 241.5l-30.6 53.1-30.7 17.7v-35.4l30.7-53.1z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st53",
  d: "M497.5 294.6l-30.7-17.7-30.7 17.7 30.7 17.7zm30.6-123.9l-61.3 35.4-30.7-17.7 30.7-17.7 30.7 3.7z"
});

var _ref111 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_55_",
  gradientUnits: "userSpaceOnUse",
  x1: 533.428,
  y1: 72.821,
  x2: 412.812,
  y2: 282.125
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref112 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_55_)",
  d: "M466.8 170.7V99.8l30.7 53.2 30.6 17.7-30.6 3.7z"
});

var _ref113 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_56_",
  gradientUnits: "userSpaceOnUse",
  x1: 392.138,
  y1: 269.188,
  x2: 582.521,
  y2: 366.154
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref114 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_56_)",
  d: "M466.8 206.1v70.8l-30.7 17.7v70.3l-92.2-17.1v-35.5l30.8-17.7 61.4-106.2z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st53",
  d: "M589.5 241.5c-.6-.2 30.7 0 30.7 0L589 262.2l-30.2-3 30.7-17.7z"
});

var _ref116 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_57_",
  gradientUnits: "userSpaceOnUse",
  x1: 615.754,
  y1: 226.64,
  x2: 626.396,
  y2: 330.701
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref117 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_57_)",
  d: "M620.1 241.5L589 262.2l31.1 67.8 31.1-53.3z"
});

var _ref118 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_58_",
  gradientUnits: "userSpaceOnUse",
  x1: 593.336,
  y1: 292.384,
  x2: 515.29,
  y2: 337.32
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref119 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_58_)",
  d: "M589 262.2l31.1 67.8h-61.3v-70.8z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  fill: "#23c386",
  d: "M436.1 294.6l30.7 17.7v70.9l-30.7-18.3z"
});

var _ref121 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_59_",
  gradientUnits: "userSpaceOnUse",
  x1: 509.971,
  y1: 330.443,
  x2: 386.991,
  y2: 348.181
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref122 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_59_)",
  d: "M436.1 294.6l30.7 17.7v70.9l-30.7-18.3z"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st61",
  d: "M655.3 270.2L620.1 330h-61.3l-92 53.2-30.7-18.3-92.2-17.1v-35.5l-40.1-23.5"
});

var _ref124 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_60_",
  gradientUnits: "userSpaceOnUse",
  x1: 234.911,
  y1: 360.257,
  x2: 285.759,
  y2: 405.192
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_60_)",
  d: "M170.4 386.7l21.1-35.1 19.8-4 40.9-55.4v141.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_61_",
  gradientUnits: "userSpaceOnUse",
  x1: 252.25,
  y1: 363.04,
  x2: 293.178,
  y2: 363.04
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_61_)",
  d: "M252.2 292.2v141.7l41-23.6v-48.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st53",
  d: "M280.3 366.6l23.5-13.6 23.5 13.6-23.5 13.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8e9dcf",
  d: "M303.8 380.2v69.1l-34.5-20 11-62.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__SVGID_62_",
  gradientUnits: "userSpaceOnUse",
  x1: 259.085,
  y1: 312.339,
  x2: 332.401,
  y2: 436.502
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-main_svg__SVGID_62_)",
  d: "M303.8 380.2l23.5-13.6 6.8 65.2-30.3 17.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st61",
  d: "M166.2 384.2l86 49.7 18.1-10.4-1 5.8 34.5 20 34.6-20"
}));

var _ref125 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_719_",
  className: "iceberg-main_svg__st66",
  d: "M435.4 220.5c-5.2-2.1 1.7-10.4 2-14.4.2-3.4-2.5-11.2-2.6-14.1-.1-2.9 4.4-6.2 5.3-3.2.4 1.2-1.5.3-1.5.3s3.3-1.9 3.5 1.9c-.4.5-1.3-.3-1.3-.3s3.1-1 3 2.3c-.6-.3-1.2-.3-1.8 0-.6.3-1 .8-1.1 1.4-.4 1.8 3.3 9.7 3.2 13.6-.1 4.5-2.2 15.2-8.7 12.5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__Path_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.588,
  y1: 740.972,
  x2: 289.208,
  y2: 740.099,
  gradientTransform: "matrix(22.4188 -9.8971 -14.9738 -33.9185 5037.147 28171.592)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#23c386",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#23c386",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_718_",
  d: "M435.4 220.5c-5.2-2.1 1.7-10.4 2-14.4.2-3.4-2.5-11.2-2.6-14.1-.1-2.9 4.4-6.2 5.3-3.2.4 1.2-1.5.3-1.5.3s3.3-1.9 3.5 1.9c-.4.5-1.3-.3-1.3-.3s3.1-1 3 2.3c-.6-.3-1.2-.3-1.8 0-.6.3-1 .8-1.1 1.4-.4 1.8 3.3 9.7 3.2 13.6-.1 4.5-2.2 15.2-8.7 12.5z",
  fill: "url(#iceberg-main_svg__Path_1_)"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_717_",
  className: "iceberg-main_svg__st66",
  d: "M442.7 216.4l1.9 8.4 5.5.2s-1.1 6.3 1 8.2c2.1 1.9 3.7.9 5.9 1.7.4-1.1-1.3-2.3-1.3-2.3.8-.1 1.7 0 2.5.3.4-1.2-1.2-2.2-1.2-2.2.6-.1 1.3-.1 1.9.1.3-1.8-3.6-2-3.6-2s4.5-8.6-1.2-11.2c-4.9-2.1-11.4-1.2-11.4-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_716_",
  className: "iceberg-main_svg__st66",
  d: "M450.7 225.7c-4.3-4-10.7-3.5-10.7-3.5s-8.6 1.9-5.4 5.5c3.2 3.6 8.3 5.1 8.3 5.1s-3.2 6.1-1.7 8.8c1.5 2.7 3.8 2.4 5.6 3.7 1.1-1.4-.7-2.5-.7-2.5 1.1 0 2.2.2 3.1.7.5-1.4-1-2.4-1-2.4.9-.3 1.9-.3 2.9 0-.2-2.3-4-2.5-4-2.5s8.6-8.4 3.6-12.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_715_",
  className: "iceberg-main_svg__st66",
  d: "M446.2 210.4c-2-6.1-13-5.5-12.6-2.5.9 7-2.2 8.7-1.7 13.9.5 4.9 2.7 7.2 6.3 7.9 4.3.9 7.6-2.1 9.7-6.4 1.9-4-.7-9.6-1.7-12.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_712_",
  className: "iceberg-main_svg__st66",
  d: "M445.3 193.5c-3-2.6-10.9-2.6-15.3 4.2-1.4 2.2 3.3 1.1 1 5.9-3.4 7 12.8 10.2 16.6 8.7.5-.2 2.9-3.2 2.4-5l.3-1.5c1.3-.7.2-2.5-.2-3 .7-1.1.8-2.5.3-3.8-.6-1.2-3.8-4.3-5.1-5.5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__Path_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 321.396,
  y1: 725.108,
  x2: 321.603,
  y2: 723.244,
  gradientTransform: "matrix(24.1659 0 0 -23.7614 -7329.84 17400.563)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#23c386",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#23c386",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_711_",
  d: "M445.3 193.5c-3-2.6-10.9-2.6-15.3 4.2-1.4 2.2 3.3 1.1 1 5.9-3.4 7 12.8 10.2 16.6 8.7.5-.2 2.9-3.2 2.4-5l.3-1.5c1.3-.7.2-2.5-.2-3 .7-1.1.8-2.5.3-3.8-.6-1.2-3.8-4.3-5.1-5.5z",
  fill: "url(#iceberg-main_svg__Path_2_)"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Shape_23_",
  d: "M450.4 199.1c-.5-1.3-3.8-4.4-5.1-5.6-3-2.6-10.9-2.6-15.3 4.2-1.4 2.2 3.3 1.1 1 5.9-3.4 7 12.8 10.2 16.6 8.7.5-.2 1.9-2.9 2.6-5.4l-.9-.9v-.1l.1-.1h1c.3-1 .2-2.1-.3-3 .7-1 .8-2.4.3-3.7zm-12.6 8.1c-.1 0-.1 0 0 0l-.3-.2c-.4-.2-.6-.5-.8-.9v-.2h.1c.1.2.3.3.5.4.3.1.6.2.9.2l-.4.7zm1 .5c-.2-.1-.5-.2-.7-.3l.5-.6.2.9c.1 0 0 0 0 0zm.5 0l-.3-1v-.1h.3c.2 0 .4 0 .7-.1h.2v.2l-.9 1zm2.1.5c-.6 0-1.2-.1-1.7-.2 0 0-.1 0-.1-.1v-.1l1-1.2.9 1.5v.1c0-.1 0 0-.1 0zm.7-.1s-.1 0 0 0l-1-1.6v-.1h.1l.7-.1c.4-.1.8-.1 1.2-.2h.1c.1 0 .1.1.1.1l-1.2 1.9zm2.2.1h-1.7c-.1 0-.1-.1-.1-.2l1-1.7h.1l.9 1.7c-.1.2-.1.3-.2.2zm.6-.1l-1-1.9c0-.1.1-.1.1-.1l.8-.1h.8s.1 0 .1.1v.1l-.8 1.9zm2.1-.1c-.5.1-1 .1-1.6.2h-.1c-.1 0-.1-.1-.1-.2l.6-1.7 1.2 1.5v.2zm.6-.2s-.1 0 0 0l-1.4-1.7v-.1c0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.2l-.7 1.7zm2.3-.7s0 .1-.1.2c-.5.2-1.1.3-1.7.5h-.1s-.1 0-.1-.1v-.1l.7-1.6h.1c.2.2.9.8 1.2 1.1z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_710_",
  className: "iceberg-main_svg__st70",
  d: "M450.3 205.9h-.9c-.1 0-.1 0-.1.1v.1l.9.9c0-.5.1-.8.1-1.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_709_",
  className: "iceberg-main_svg__st70",
  d: "M448.7 206l-.7 1.6v.1l.1.1h.1c.6-.1 1.1-.3 1.7-.5.1 0 .1-.1.1-.2-.4-.2-1.1-.9-1.3-1.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_708_",
  className: "iceberg-main_svg__st70",
  d: "M448.2 205.9h-1.9c-.1 0-.1 0-.1.1v.1l1.4 1.7h.1l.7-1.7c-.1-.1-.1-.2-.2-.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_707_",
  className: "iceberg-main_svg__st70",
  d: "M445.9 206.2l-.6 1.7c0 .1 0 .1.1.2h.1c.6-.1 1.1-.1 1.6-.2h.1v-.2l-1.3-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_706_",
  className: "iceberg-main_svg__st70",
  d: "M445.5 205.9h-.8l-.8.1c-.1 0-.1.1-.1.1l1 1.9.7-2.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_705_",
  className: "iceberg-main_svg__st70",
  d: "M443.6 206.4s-.1 0 0 0l-1 1.7c0 .1 0 .1.1.2h1.7c.1 0 .2-.1.2-.1l-1-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_704_",
  className: "iceberg-main_svg__st70",
  d: "M443.2 206c-.5.1-.9.1-1.3.2l-.7.1h-.1v.1l.9 1.6h.1l1.1-1.9c.1 0 0 0 0-.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_703_",
  className: "iceberg-main_svg__st70",
  d: "M440.8 206.5l-1 1.2v.1s0 .1.1.1c.6.1 1.2.2 1.7.2.1 0 .2 0 .2-.1v-.1l-1-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_702_",
  className: "iceberg-main_svg__st70",
  d: "M440.2 206.5c-.1 0-.1 0 0 0h-.2c-.3 0-.5 0-.7.1H439v.1l.3 1 .9-1.2c-.1.1 0 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_701_",
  className: "iceberg-main_svg__st70",
  d: "M438.6 206.7l-.5.6c.2.1.5.2.7.3.1 0 .1 0 .1-.1l-.3-.8c0-.1 0 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_700_",
  className: "iceberg-main_svg__st70",
  d: "M438.2 206.5c-.3 0-.6-.1-.9-.2-.2-.1-.4-.2-.5-.4h-.1v.2c.1.4.4.7.8.9l.3.2h.1l.3-.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_699_",
  className: "iceberg-main_svg__st66",
  d: "M421.4 191.8c.1-.1.2-.1.3-.1.1 0 .2 0 .3.1 2.2 1.5 4.8 2.4 7.5 2.6.7 0 1.4.2 2 .4.5.2.9.5 1.2.9 1.2 1.7 1 7.8-1.9 9.8-1 .2-2.1.1-3.1-.3l.6-1.6-1.8.9c-.9-.8-1.5-1.7-1.9-2.8l1.2-1-1.6-.2c-.1-.3-.1-.6-.2-.9-.3-2.7-1.9-4.9-2.3-6-.1-.2-.5-1.1-.6-1.3 0-.1.1-.3.3-.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_698_",
  className: "iceberg-main_svg__st66",
  d: "M421.4 191.8c.1-.1.2-.1.3-.1.1 0 .2 0 .3.1 2.2 1.5 4.8 2.4 7.5 2.6.7 0 1.4.2 2 .4.5.2.9.5 1.2.9 1.2 1.7 1 7.8-1.9 9.8-1 .2-2.1.1-3.1-.3l.6-1.6-1.8.9c-.9-.8-1.5-1.7-1.9-2.8l1.2-1-1.6-.2c-.1-.3-.1-.6-.2-.9-.3-2.7-1.9-4.9-2.3-6-.1-.2-.5-1.1-.6-1.3 0-.1.1-.3.3-.5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__Path_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 311.885,
  y1: 730.524,
  x2: 312.158,
  y2: 727.65,
  gradientTransform: "matrix(13.8612 0 0 -15.9404 -3897.868 11816.098)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#23c386",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#23c386",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_697_",
  d: "M421.4 191.8c.1-.1.2-.1.3-.1.1 0 .2 0 .3.1 2.2 1.5 4.8 2.4 7.5 2.6.7 0 1.4.2 2 .4.5.2.9.5 1.2.9 1.2 1.7 1 7.8-1.9 9.8-1 .2-2.1.1-3.1-.3l.6-1.6-1.8.9c-.9-.8-1.5-1.7-1.9-2.8l1.2-1-1.6-.2c-.1-.3-.1-.6-.2-.9-.3-2.7-1.9-4.9-2.3-6-.1-.2-.5-1.1-.6-1.3 0-.1.1-.3.3-.5z",
  fill: "url(#iceberg-main_svg__Path_3_)"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_696_",
  className: "iceberg-main_svg__st66",
  d: "M442.8 193.8c.3-.2 1.4.1 1.4.1.3.1.4.3.3.4-.4.2-.8.3-1.2.2-.6-.1-.7-.5-.5-.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_695_",
  className: "iceberg-main_svg__st66",
  d: "M442.6 195.1c.6.1.2.8-.2.9-.4.1-1-.2-.9-.5.2-.3.8-.5 1.1-.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_694_",
  className: "iceberg-main_svg__st66",
  d: "M440.7 193.5c.5.1.9.4 1 .9 0 .3-.3.4-1.1.5-.8.1-1.5-.4-1.5-.7 0-.3 1.1-.6 1.6-.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "iceberg-main_svg__Brow_Eyes_2_"
}, /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_693_",
  className: "iceberg-main_svg__st66",
  d: "M443.5 202.5c.4 0 .7-.1 1-.3 0 0-.7-.2-1.6-.6-2.5-1-4.2-2.5-5.5-2.4-.8 0-1 1.2-1 1.2.4-.1.9-.2 1.3-.2.9.1 1.8.4 2.6.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_692_",
  className: "iceberg-main_svg__st72",
  d: "M440.3 201.1c-.8-.2-1.6-.3-2.4-.3 0 .3 0 .6.1 1 .2 1.4 1.5 2.4 2.8 2.2 1.1 0 2.1-.5 2.7-1.5"
})), /*#__PURE__*/React.createElement("g", {
  id: "iceberg-main_svg__Brow_Eyes-2_2_"
}, /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_691_",
  className: "iceberg-main_svg__st73",
  d: "M441.2 201.9c-.6-.2-1.2-.3-1.8-.3v.6c.1.8.9 1.4 1.7 1.3.6 0 1.3-.3 1.6-.9-.5-.3-1-.6-1.5-.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "iceberg-main_svg__Brow_Eyes-3_1_"
}, /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_690_",
  className: "iceberg-main_svg__st66",
  d: "M448.6 201.5c.4-.3.9-.6 1.4-.7.2 0 .5.1.7.2 0 0-.1-.9-.5-.9-.7 0-1.6 1-2.9 1.7-.5.3-1 .5-1.1.5.3.1.5.1.8.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_689_",
  className: "iceberg-main_svg__st72",
  d: "M446.9 202.5c.2.6.7 1.1 1.4 1.1.9 0 1.4-.8 1.5-1.6 0-.2.1-.5 0-.7-.4 0-.9 0-1.3.2"
})), /*#__PURE__*/React.createElement("g", {
  id: "iceberg-main_svg__Brow_Eyes-4_1_"
}, /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_688_",
  className: "iceberg-main_svg__st73",
  d: "M448.2 202.1c.3-.1.6-.2.9-.2v.4c0 .4-.4.8-.8.8-.3 0-.7-.2-.8-.6.1-.2.4-.3.7-.4z"
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_687_",
  className: "iceberg-main_svg__st70",
  d: "M441.8 202.1s.8.1.9.5c0 .4-1.2-.3-1.6-.4-.3-.1-.1-.2.7-.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_686_",
  className: "iceberg-main_svg__st70",
  d: "M448.2 202.2s-.5.1-.6.4c0 .3.8-.3 1-.4.2-.1 0-.2-.4 0z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__Path_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 380.333,
  y1: 706.849,
  x2: 378.993,
  y2: 707.534,
  gradientTransform: "matrix(22.8173 16.3359 13.5213 -18.8859 -17772.975 7397.19)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#23c386",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#23c386",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_714_",
  d: "M450.7 225.7c-4.3-4-10.7-3.5-10.7-3.5s-8.6 1.9-5.4 5.5c3.2 3.6 8.3 5.1 8.3 5.1s-3.2 6.1-1.7 8.8c1.5 2.7 3.8 2.4 5.6 3.7 1.1-1.4-.7-2.5-.7-2.5 1.1 0 2.2.2 3.1.7.5-1.4-1-2.4-1-2.4.9-.3 1.9-.3 2.9 0-.2-2.3-4-2.5-4-2.5s8.6-8.4 3.6-12.9z",
  fill: "url(#iceberg-main_svg__Path_4_)"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_685_",
  className: "iceberg-main_svg__st66",
  d: "M459.6 200.5c.2-1.7-.6-2.2-1.5-2.4-.3-2.9-5.3-1-6 1.8-.7 2.8-1 10.4-3.3 11.2-3.3 1.2-10.9 0-11.1 5.7-.2 6.2 11.8 2.9 15.5-.5 2.8-2.6 3.3-10.9 4.2-12.6.3-.6.8-1 1.5-1.1.6-.1 1.3.1 1.8.5.4-1.5-.3-2.3-1.1-2.6z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-main_svg__Path_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 301.965,
  y1: 762.311,
  x2: 301.397,
  y2: 762.146,
  gradientTransform: "matrix(30.6416 -14.0349 -8.8023 -19.2175 -2071.497 19082.574)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#23c386",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#23c386",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-main_svg__Path_682_",
  d: "M459.6 200.5c.2-1.7-.6-2.2-1.5-2.4-.3-2.9-5.3-1-6 1.8-.7 2.8-1 10.4-3.3 11.2-3.3 1.2-10.9 0-11.1 5.7-.2 6.2 11.8 2.9 15.5-.5 2.8-2.6 3.3-10.9 4.2-12.6.3-.6.8-1 1.5-1.1.6-.1 1.3.1 1.8.5.4-1.5-.3-2.3-1.1-2.6z",
  fill: "url(#iceberg-main_svg__Path_5_)"
}));

var _ref126 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M521.4 434.6h2.8c1.7 0 2.7.4 3.4 1.2.7.8.9 2 .9 3.2 0 1.3-.4 2.4-.9 3-.7.9-1.8 1.4-3.4 1.4h-2.8v-8.8zm2.8 7.2c1 0 1.6-.3 1.9-.8.4-.5.5-1.2.5-2 0-.9-.2-1.6-.6-2-.4-.5-1-.7-1.7-.7h-1v5.5h.9zm6.7-7.2h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7v-8.7zm8.1 0h3.1c1.9 0 3.4.4 3.4 2.8s-1.6 3-3.4 3h-1.4v3H539v-8.8zm3.2 4.2c.9 0 1.4-.2 1.4-1.2 0-1.1-.5-1.3-1.5-1.3h-1.3v2.5h1.4zm5.4-4.2h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7v-8.7zm8.1 0h2.1l2.1 4c.4.7.7 1.3 1 2v-5.9h1.7v8.8h-2.1l-2.1-4c-.4-.7-.7-1.3-1-2v5.9h-1.7v-8.8zm9.6 0h2.8c1.7 0 2.7.4 3.4 1.2.7.8.9 2 .9 3.2 0 1.3-.4 2.4-.9 3-.7.9-1.8 1.4-3.4 1.4h-2.8v-8.8zm2.8 7.2c1 0 1.6-.3 1.9-.8.4-.5.5-1.2.5-2 0-.9-.2-1.6-.6-2-.4-.5-1-.7-1.7-.7h-1v5.5h.9zm6.7-7.2h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7v-8.7zm8.1 0h2.1l2.1 4c.4.7.7 1.3 1 2v-5.9h1.7v8.8h-2.1l-2.1-4c-.4-.7-.7-1.3-1-2v5.9h-1.7v-8.8zm13.1-.1c1.7 0 3.3.9 3.3 2.8 0 .2 0 .4-.1.6l-1.8.3v-.5c0-1-.5-1.5-1.4-1.5-1.4 0-1.9 1.4-1.9 3s.5 3 2 3c1.1 0 1.7-.8 1.7-2l1.6.3v.3c0 2.1-1.7 3-3.4 3-2.5 0-3.8-1.8-3.8-4.5 0-3 1.4-4.8 3.8-4.8zm5.8.1h1.8v8.8h-1.8v-8.8zm4.5 0h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7v-8.7zm7.8 5.9l1.7-.2v.4c0 1 .7 1.4 1.6 1.4.8 0 1.5-.3 1.5-1.1 0-.9-1-1-2.2-1.2-1.5-.3-2.5-.9-2.5-2.4 0-1.8 1.4-2.8 3.3-2.8 1.4 0 3.1.6 3.1 2.4v.4l-1.7.2v-.3c0-.8-.6-1.2-1.4-1.2-.7 0-1.3.2-1.3 1s.9.9 2.1 1.1c1.6.4 2.7.9 2.7 2.5 0 1.9-1.4 2.9-3.5 2.9-1.5 0-3.2-.6-3.2-2.5-.3-.2-.2-.4-.2-.6z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "iceberg-main_svg__st76",
  cx: 507.6,
  cy: 438.1,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M466.1 437.6h40.4v1h-40.4zM525 464.5c1.7 0 3.3.9 3.3 2.8 0 .2 0 .4-.1.6l-1.8.3v-.5c0-1-.5-1.5-1.4-1.5-1.4 0-1.9 1.4-1.9 3s.5 3 2 3c1.1 0 1.7-.8 1.7-2l1.6.3v.3c0 2.1-1.7 3-3.4 3-2.5 0-3.8-1.8-3.8-4.5 0-3 1.3-4.8 3.8-4.8zm9.3 0c2.4 0 3.8 1.7 3.8 4.5s-1.3 4.6-3.9 4.6c-2.4 0-3.8-1.7-3.8-4.5 0-2.9 1.4-4.6 3.9-4.6zm1.9 4.6c0-1.6-.5-3-2-3-1.4 0-1.9 1.4-1.9 2.9 0 1.6.5 3 2 3 1.4 0 1.9-1.4 1.9-2.9zm4.3-4.5h2.1l2.1 4c.4.7.7 1.3 1 2v-5.9h1.7v8.8h-2.1l-2.1-4c-.4-.7-.7-1.3-1-2v5.9h-1.7v-8.8zm9.6 0h5.6v1.6H552v2h3.3v1.6H552v3.6h-1.8v-8.8zm7.7 0h1.8v8.8h-1.8v-8.8zm8.1-.1c1.6 0 3.2.7 3.2 2.6v.5l-1.8.3v-.3c0-1.1-.6-1.4-1.4-1.4-1.4 0-2 1.2-2 3 0 1.7.5 3 2.2 3 .4 0 1-.1 1.4-.4v-1.2h-1.6V469h3.4v3.6c-.9.8-2 1.2-3.4 1.2-2.6 0-3.9-1.7-3.9-4.5 0-3 1.3-4.8 3.9-4.8zm5.9.1h1.8v5.4c0 1.4.5 1.9 1.7 1.9s1.6-.6 1.6-1.9v-5.5h1.7v5.4c0 2.6-1.3 3.6-3.6 3.6-2.1 0-3.4-.8-3.4-3.5v-5.4zm9.6 0h3.1c1.5 0 3.2.4 3.2 2.5 0 1.1-.5 1.9-1.5 2.2.6.2.9.6 1.1 1.2.3 1.3.4 1.8.8 2.9H586c-.3-1-.4-2.1-.6-2.6-.1-.5-.3-.7-1-.7h-1.3v3.3h-1.8v-8.8zm3.1 4c.8 0 1.3-.2 1.3-1.2s-.5-1.2-1.4-1.2h-1.2v2.3h1.3zm8.2-4h2.2l2.9 8.8h-1.9l-.7-2.3h-2.9l-.7 2.3h-1.9l3-8.8zm2 5l-.3-.9c-.2-.8-.5-1.5-.7-2.3-.2.8-.4 1.5-.7 2.3l-.3.9h2zm6.3-3.3h-2.6v-1.7h7.1v1.7h-2.6v7.1H601v-7.1zm6.4-1.7h1.8v8.8h-1.8v-8.8zm8.1-.1c2.4 0 3.8 1.7 3.8 4.5s-1.3 4.6-3.9 4.6c-2.4 0-3.8-1.7-3.8-4.5.1-2.9 1.4-4.6 3.9-4.6zm1.9 4.6c0-1.6-.5-3-2-3-1.4 0-1.9 1.4-1.9 2.9 0 1.6.5 3 2 3 1.4 0 1.9-1.4 1.9-2.9zm4.3-4.5h2.1l2.1 4c.4.7.7 1.3 1 2v-5.9h1.7v8.8h-2.1l-2.1-4c-.4-.7-.7-1.3-1-2v5.9h-1.7v-8.8z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "iceberg-main_svg__st76",
  cx: 507.6,
  cy: 468.1,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M466.1 467.6h40.4v1h-40.4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M521.4 494.6h1.8v8.8h-1.8v-8.8zm4.6 0h2.1l2.1 4c.4.7.7 1.3 1 2v-5.9h1.7v8.8h-2.1l-2.1-4c-.4-.7-.7-1.3-1-2v5.9H526v-8.8zm9.6 0h5.6v1.6h-3.7v2h3.3v1.6h-3.3v3.6h-1.8v-8.8zm7.6 0h3.1c1.5 0 3.2.4 3.2 2.5 0 1.1-.5 1.9-1.5 2.2.6.2.9.6 1.1 1.2.3 1.3.4 1.8.8 2.9h-2.1c-.3-1-.4-2.1-.6-2.6-.1-.5-.3-.7-1-.7h-1.3v3.3h-1.8v-8.8zm3.2 4c.8 0 1.3-.2 1.3-1.2s-.5-1.2-1.4-1.2h-1.2v2.3h1.3zm8.2-4h2.2l2.9 8.8h-1.9l-.7-2.3h-2.9l-.7 2.3h-1.9l3-8.8zm2 5l-.3-.9c-.2-.8-.5-1.5-.7-2.3-.2.8-.4 1.5-.7 2.3l-.3.9h2zm4.7.9l1.7-.2v.4c0 1 .7 1.4 1.6 1.4.8 0 1.5-.3 1.5-1.1 0-.9-1-1-2.2-1.2-1.5-.3-2.5-.9-2.5-2.4 0-1.8 1.4-2.8 3.3-2.8 1.4 0 3.1.6 3.1 2.4v.4l-1.7.2v-.3c0-.8-.6-1.2-1.4-1.2-.7 0-1.3.2-1.3 1s.9.9 2.1 1.1c1.6.4 2.7.9 2.7 2.5 0 1.9-1.4 2.9-3.5 2.9-1.5 0-3.2-.6-3.2-2.5-.2-.2-.2-.4-.2-.6zm11-4.2h-2.6v-1.7h7.1v1.7h-2.6v7.1h-1.8v-7.1zm6.4-1.7h3.1c1.5 0 3.2.4 3.2 2.5 0 1.1-.5 1.9-1.5 2.2.6.2.9.6 1.1 1.2.3 1.3.4 1.8.8 2.9h-2.1c-.3-1-.4-2.1-.6-2.6-.1-.5-.3-.7-1-.7h-1.3v3.3h-1.8v-8.8zm3.2 4c.8 0 1.3-.2 1.3-1.2s-.5-1.2-1.4-1.2h-1.2v2.3h1.3zm5.5-4h1.8v5.4c0 1.4.5 1.9 1.7 1.9s1.6-.6 1.6-1.9v-5.5h1.7v5.4c0 2.6-1.3 3.6-3.6 3.6-2.1 0-3.4-.8-3.4-3.5v-5.4zm13.1-.1c1.7 0 3.3.9 3.3 2.8 0 .2 0 .4-.1.6l-1.8.3v-.5c0-1-.5-1.5-1.4-1.5-1.4 0-1.9 1.4-1.9 3s.5 3 2 3c1.1 0 1.7-.8 1.7-2l1.6.3v.3c0 2.1-1.7 3-3.4 3-2.5 0-3.8-1.8-3.8-4.5 0-3 1.3-4.8 3.8-4.8zm7.8 1.8h-2.6v-1.7h7.1v1.7h-2.6v7.1h-1.8v-7.1zm6.4-1.7h1.8v5.4c0 1.4.5 1.9 1.7 1.9s1.6-.6 1.6-1.9v-5.5h1.7v5.4c0 2.6-1.3 3.6-3.6 3.6-2.1 0-3.4-.8-3.4-3.5v-5.4zm9.6 0h3.1c1.5 0 3.2.4 3.2 2.5 0 1.1-.5 1.9-1.5 2.2.6.2.9.6 1.1 1.2.3 1.3.4 1.8.8 2.9h-2.1c-.3-1-.4-2.1-.6-2.6-.1-.5-.3-.7-1-.7H626v3.3h-1.8v-8.8zm3.1 4c.8 0 1.3-.2 1.3-1.2s-.5-1.2-1.4-1.2h-1.2v2.3h1.3zm5.7-4h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7v-8.7z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "iceberg-main_svg__st76",
  cx: 507.6,
  cy: 498.1,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M466.1 497.6h40.4v1h-40.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M521.4 524.6h3.1c1.9 0 3.4.4 3.4 2.8s-1.6 3-3.4 3h-1.4v3h-1.8v-8.8zm3.3 4.2c.9 0 1.4-.2 1.4-1.2 0-1.1-.5-1.3-1.5-1.3h-1.3v2.5h1.4zm5.3-4.2h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6H530v-8.7zm11.6-.1c2.4 0 3.8 1.7 3.8 4.5s-1.3 4.6-3.9 4.6c-2.4 0-3.8-1.7-3.8-4.5 0-2.9 1.3-4.6 3.9-4.6zm1.9 4.6c0-1.6-.5-3-2-3-1.4 0-1.9 1.4-1.9 2.9 0 1.6.5 3 2 3 1.4 0 1.9-1.4 1.9-2.9zm4.3-4.5h3.1c1.9 0 3.4.4 3.4 2.8s-1.6 3-3.4 3h-1.4v3h-1.8v-8.8zm3.2 4.2c.9 0 1.4-.2 1.4-1.2 0-1.1-.5-1.3-1.5-1.3h-1.3v2.5h1.4zm5.4-4.2h1.8v7.1h3.6v1.7h-5.5v-8.8zm7.5 0h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7v-8.7zm12.8 4.1c-.5-.7-.7-1.3-.7-1.9 0-1.5 1.2-2.3 2.6-2.3 1.3 0 2.5.7 2.5 2.2 0 1.2-.8 1.9-2 2.4.4.5.9 1.1 1.4 1.6.3-.5.5-1.1.5-1.8l1.5.5c-.1.9-.4 1.7-.8 2.4.3.2.6.3.9.3h.4l-.1 1.7c-.1 0-.3.1-.5.1-.7 0-1.3-.3-1.9-.7-.6.5-1.4.7-2.2.7-1.6 0-3-.8-3-2.6 0-1.4.5-2.1 1.4-2.6zm1.7 3.3c.3 0 .6-.1.9-.2-.6-.6-1.2-1.3-1.7-1.9-.3.3-.4.6-.4 1 0 .6.4 1.1 1.2 1.1zm.9-5.3c0-.5-.3-.7-.7-.7-.5 0-.8.3-.8.8 0 .3.1.7.5 1.1.7-.4 1-.7 1-1.2zm9.5-2.1h3.1c1.9 0 3.4.4 3.4 2.8s-1.6 3-3.4 3h-1.4v3h-1.8v-8.8zm3.2 4.2c.9 0 1.4-.2 1.4-1.2 0-1.1-.5-1.3-1.5-1.3h-1.3v2.5h1.4zm5.4-4.2h3.1c1.5 0 3.2.4 3.2 2.5 0 1.1-.5 1.9-1.5 2.2.6.2.9.6 1.1 1.2.3 1.3.4 1.8.8 2.9H602c-.3-1-.4-2.1-.6-2.6-.1-.5-.3-.7-1-.7h-1.3v3.3h-1.8v-8.8zm3.1 4c.8 0 1.3-.2 1.3-1.2s-.5-1.2-1.4-1.2h-1.2v2.3h1.3zm9.2-4.1c2.4 0 3.8 1.7 3.8 4.5s-1.3 4.6-3.9 4.6c-2.4 0-3.8-1.7-3.8-4.5 0-2.9 1.3-4.6 3.9-4.6zm1.9 4.6c0-1.6-.5-3-2-3-1.4 0-1.9 1.4-1.9 2.9 0 1.6.5 3 2 3 1.4 0 1.9-1.4 1.9-2.9zm7.8-4.6c1.7 0 3.3.9 3.3 2.8 0 .2 0 .4-.1.6l-1.8.3v-.5c0-1-.5-1.5-1.4-1.5-1.4 0-1.9 1.4-1.9 3s.5 3 2 3c1.1 0 1.7-.8 1.7-2l1.6.3v.3c0 2.1-1.7 3-3.4 3-2.5 0-3.8-1.8-3.8-4.5 0-3 1.3-4.8 3.8-4.8zm5.8.1h5.6v1.6H627v1.8h3.4v1.6H627v2.1h3.9v1.6h-5.7v-8.7zm7.8 5.9l1.7-.2v.4c0 1 .7 1.4 1.6 1.4.8 0 1.5-.3 1.5-1.1 0-.9-1-1-2.2-1.2-1.5-.3-2.5-.9-2.5-2.4 0-1.8 1.4-2.8 3.3-2.8 1.4 0 3.1.6 3.1 2.4v.4l-1.7.2v-.3c0-.8-.6-1.2-1.4-1.2-.7 0-1.3.2-1.3 1s.9.9 2.1 1.1c1.6.4 2.7.9 2.7 2.5 0 1.9-1.4 2.9-3.5 2.9-1.5 0-3.2-.6-3.2-2.5-.3-.2-.3-.4-.2-.6zm8.7 0l1.7-.2v.4c0 1 .7 1.4 1.6 1.4.8 0 1.5-.3 1.5-1.1 0-.9-1-1-2.2-1.2-1.5-.3-2.5-.9-2.5-2.4 0-1.8 1.4-2.8 3.3-2.8 1.4 0 3.1.6 3.1 2.4v.4l-1.7.2v-.3c0-.8-.6-1.2-1.4-1.2-.7 0-1.3.2-1.3 1s.9.9 2.1 1.1c1.6.4 2.7.9 2.7 2.5 0 1.9-1.4 2.9-3.5 2.9-1.5 0-3.2-.6-3.2-2.5-.3-.2-.3-.4-.2-.6zm9-5.9h5.6v1.6h-3.8v1.8h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7v-8.7zm7.7 5.9l1.7-.2v.4c0 1 .7 1.4 1.6 1.4.8 0 1.5-.3 1.5-1.1 0-.9-1-1-2.2-1.2-1.5-.3-2.5-.9-2.5-2.4 0-1.8 1.4-2.8 3.3-2.8 1.4 0 3.1.6 3.1 2.4v.4l-1.7.2v-.3c0-.8-.6-1.2-1.4-1.2-.7 0-1.3.2-1.3 1s.9.9 2.1 1.1c1.6.4 2.7.9 2.7 2.5 0 1.9-1.4 2.9-3.5 2.9-1.5 0-3.2-.6-3.2-2.5-.3-.2-.2-.4-.2-.6z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "iceberg-main_svg__st76",
  cx: 507.6,
  cy: 528.1,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M466.1 527.6h40.4v1h-40.4z"
})));

var _ref127 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M482.8.5h2.2l2.9 8.8H486l-.7-2.3h-2.9l-.7 2.3h-1.9l3-8.8zm2.1 5l-.3-.9c-.2-.8-.5-1.5-.7-2.3-.2.8-.4 1.5-.7 2.3l-.3.9h2zm5.1-5h3.1c1.9 0 3.4.4 3.4 2.8s-1.6 3-3.4 3h-1.4v3H490V.5zm3.2 4.2c.9 0 1.4-.2 1.4-1.2 0-1.1-.5-1.3-1.5-1.3h-1.3v2.5h1.4zm5.4-4.2h3.1c1.9 0 3.4.4 3.4 2.8s-1.6 3-3.4 3h-1.4v3h-1.8V.5zm3.2 4.2c.9 0 1.4-.2 1.4-1.2 0-1.1-.5-1.3-1.5-1.3h-1.3v2.5h1.4zm5.4-4.2h1.8v7.1h3.6v1.7h-5.5V.5zm7.5 0h1.8v8.8h-1.8V.5zm8-.2c1.7 0 3.3.9 3.3 2.8 0 .2 0 .4-.1.6l-1.8.3v-.5c0-1-.5-1.5-1.4-1.5-1.4 0-1.9 1.4-1.9 3s.5 3 2 3c1.1 0 1.7-.8 1.7-2l1.6.3v.3c0 2.1-1.7 3-3.4 3-2.5 0-3.8-1.8-3.8-4.5 0-3 1.4-4.8 3.8-4.8zm7.9.2h2.2l2.9 8.8h-1.9l-.7-2.3h-2.9l-.7 2.3h-1.9l3-8.8zm2 5l-.3-.9c-.2-.8-.5-1.5-.7-2.3-.2.8-.4 1.5-.7 2.3l-.3.9h2zm6.3-3.3h-2.6V.5h7.1v1.7h-2.6v7.1H539V2.2zm6.4-1.7h1.8v8.8h-1.8V.5zm8.1-.2c2.4 0 3.8 1.7 3.8 4.5s-1.3 4.6-3.9 4.6c-2.4 0-3.8-1.7-3.8-4.5.1-2.8 1.4-4.6 3.9-4.6zm1.9 4.7c0-1.6-.5-3-2-3-1.4 0-1.9 1.4-1.9 2.9 0 1.6.5 3 2 3 1.4 0 1.9-1.4 1.9-2.9zm4.3-4.5h2.1l2.1 4c.4.7.7 1.3 1 2v-6h1.7v8.8h-2.1l-2.1-4c-.4-.7-.7-1.3-1-2v5.9h-1.7V.5zm16.9-.2c1.7 0 3.3.9 3.3 2.8 0 .2 0 .4-.1.6l-1.8.3v-.5c0-1-.5-1.5-1.4-1.5-1.4 0-1.9 1.4-1.9 3s.5 3 2 3c1.1 0 1.7-.8 1.7-2l1.6.3v.3c0 2.1-1.7 3-3.4 3-2.5 0-3.8-1.8-3.8-4.5 0-3 1.3-4.8 3.8-4.8zm9.3 0c2.4 0 3.8 1.7 3.8 4.5s-1.3 4.6-3.9 4.6c-2.4 0-3.8-1.7-3.8-4.5.1-2.8 1.4-4.6 3.9-4.6zm1.9 4.7c0-1.6-.5-3-2-3-1.4 0-1.9 1.4-1.9 2.9 0 1.6.5 3 2 3 1.4 0 1.9-1.4 1.9-2.9zM592 .5h2.8c1.7 0 2.7.4 3.4 1.2.7.8.9 2 .9 3.2 0 1.3-.4 2.4-.9 3-.7.9-1.8 1.4-3.4 1.4H592V.5zm2.8 7.2c1 0 1.6-.3 1.9-.8.4-.5.5-1.2.5-2 0-.9-.2-1.6-.6-2-.4-.5-1-.7-1.7-.7h-1v5.5h.9zm6.7-7.2h5.6v1.6h-3.8V4h3.4v1.6h-3.4v2.1h3.9v1.6h-5.7V.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "iceberg-main_svg__st76",
  cx: 466.7,
  cy: 4,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-main_svg__st76",
  d: "M466.8 73.8c-.3 0-.5-.2-.5-.5L466.2 4c0-.3.2-.5.5-.5s.5.2.5.5l.1 69.3c0 .3-.2.5-.5.5z"
}));

function SvgIcebergMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iceberg-main_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1065.8 1027",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127);
}

export default __webpack_public_path__ + "static/iceberg-main.974806cd.svg";
export { SvgIcebergMain as ReactComponent };